import { FavoriteCollectionService } from '@aipb/gulliver/personal-content/data-access';
import { NibbleAction } from '@aipb/gulliver/personal-content/model';
import { PersonalContentRouting } from '@aipb/gulliver/personal-content/routing';
import { openUrl } from '@aipb/shared/util/routing';
import { NibbleActionHandler } from '../nibble-action.handler';

export class CollectionNibbleActionHandler implements NibbleActionHandler {
  constructor(
    private favoriteCollectionService: FavoriteCollectionService,
    private personalContentRouting: PersonalContentRouting
  ) {}

  handle(nibbleAction: NibbleAction) {
    const serviceValue = nibbleAction.nibbleCut.cut.serviceValue;

    this.favoriteCollectionService.get(serviceValue).subscribe((collection) => {
      const url = this.personalContentRouting.collectionSingleAbsUrl(collection.collection.id);
      openUrl(url);
    });
  }

  getUrl(nibbleAction: NibbleAction): string {
    const serviceValue = nibbleAction.nibbleCut.cut.serviceValue;
    return this.personalContentRouting.collectionSingleAbsUrl(serviceValue);
  }

  useResolver(): boolean {
    return false;
  }
}
